var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"slider",staticClass:"beer-slider",attrs:{"data-beer-label":_vm.afterText}},[_c('img',{attrs:{"src":_vm.after,"alt":_vm.secondary_alt}}),_vm._v(" "),_c('div',{staticClass:"beer-reveal",attrs:{"data-beer-label":_vm.beforeText}},[_c('img',{attrs:{"src":_vm.before,"atl":_vm.primary_alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }